export enum DictumStatus {
    A = 1,
    B = 2,
    C = 3
  }
  
export const DictumStatusValues: { [id: number]: string } = {
1: 'A',
2: 'B',
3: 'C'
};
  
export namespace DictumStatus {
export function values() {
    return Object.keys(DictumStatus)
    .filter(type => isNaN(<any>type) && type !== 'values')
    .map((key, index) => {
        return { key: DictumStatusValues[+index + 1], value: +index + 1 };
    });
}
}
  